import { render, staticRenderFns } from "./thirdCard.vue?vue&type=template&id=70c59a82&scoped=true"
import script from "./thirdCard.vue?vue&type=script&lang=js"
export * from "./thirdCard.vue?vue&type=script&lang=js"
import style0 from "./thirdCard.vue?vue&type=style&index=0&id=70c59a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c59a82",
  null
  
)

export default component.exports